module.exports = __webpack_public_path__ + "static/media/background-thu-vien-nghia dung.85a18742.png";